module.exports = __webpack_public_path__ + "static/publication-b0bf47a34dea4b1e15f6dd88159c36e5.mp4";